import { createReducer } from 'redux-starter-kit';
import {
  MetaType,
  RiskAssetAllocationType,
  ReturnForecastType,
  RiskCapacityLevelType,
  RiskRequirementLevelType,
  RiskDescriptionsType,
  ModelPortfolioType
} from './types';
import {
  META_LOADED,
  GET_META_TIME_HORIZON,
  GET_META_RISK_LEVEL,
  GET_META_ASSET_CLASS,
  GET_META_KNOWLEDGE_LEVEL,
  GET_META_POLICY_PROVIDER,
  GET_META_POLICY_TYPE,
  GET_META_POLICY_PLATFORM,
  GET_META_POLICY_CHARGE_TYPE,
  GET_META_RISK_ASSET_ALLOCATION,
  GET_META_RETURN_FORECASTS,
  GET_META_RETURN_FORECAS_TYPES,
  GET_META_RISK_CAPACITY,
  GET_RISK_REQUIREMENT_LEVELS,
  GET_META_POLICY_ACTION_TYPE,
  SET_META_CONTRIBUTION_ACCOUNTS,
  SET_META_CONTRIBUTION_FREQUENCIES,
  SET_META_CONTRIBUTION_SOURCES,
  SET_IS_LOADING_META,
  SET_META_ADVISOR_CHARGE_TYPES,
  SET_META_ADVISOR_CHARGE_ACCOUNTS,
  SET_RISK_DESCRIPTIONS,
  SET_META_ASSET_CLASSES,
  SET_META_CIP_THRESHOLDS,
  SET_MODEL_PORTFOLIOS,
  SET_POLICY_TYPE_RECOMMENDED,
  SET_CHARGE_SOURCES,
  SET_BENCHMARKS,
  SET_CASH_FUND,
  SET_BENCHMARK_CONFIG
} from './actions';
interface MetaState {
  isMetaLoaded: boolean;
  isLoadingMeta: boolean;
  timeHorizons: Array<MetaType>;
  riskLevels: Array<MetaType>;
  assetClasses: Array<MetaType>;
  knowledgeLevels: Array<MetaType>;
  policyProviders: Array<MetaType>;
  policyTypes: Array<MetaType>;
  policyPlatforms: Array<MetaType>;
  policyChargeTypes: Array<MetaType>;
  riskAssetAllocations: Array<RiskAssetAllocationType>;
  returnForecasts: Array<ReturnForecastType>;
  returnForecastTypes: Array<MetaType>;
  riskCapacity: Array<RiskCapacityLevelType>;
  riskRequirementLevels: Array<RiskRequirementLevelType>;
  policyActionTypes: Array<MetaType>;
  contributionAccounts: Array<MetaType>;
  contributionFrequencies: Array<MetaType>;
  contributionSources: Array<MetaType>;
  advisorChargeTypes: Array<MetaType>;
  advisorChargeAccounts: Array<MetaType>;
  riskDescriptions: Array<RiskDescriptionsType>;
  assetClassesNew: Array<MetaType>;
  cipThresHolds: Array<MetaType>;
  modelPortfolios: ModelPortfolioType[];
  policyTypesRecommended: Array<MetaType>;
  chargeSources: Array<MetaType>;
  benchmarks: Array<MetaType>;
  cashFund: Array<MetaType>;
  benchmarkConfig: Array<number>;
}

const INITIAL_STATE: MetaState = {
  isMetaLoaded: false,
  isLoadingMeta: false,
  timeHorizons: [],
  riskLevels: [],
  assetClasses: [],
  knowledgeLevels: [],
  policyProviders: [],
  policyTypes: [],
  policyPlatforms: [],
  policyChargeTypes: [],
  riskAssetAllocations: [],
  returnForecasts: [],
  returnForecastTypes: [],
  riskRequirementLevels: [],
  riskCapacity: [],
  policyActionTypes: [],
  contributionAccounts: [],
  contributionFrequencies: [],
  contributionSources: [],
  advisorChargeTypes: [],
  advisorChargeAccounts: [],
  riskDescriptions: [],
  assetClassesNew: [],
  cipThresHolds: [],
  modelPortfolios: [],
  policyTypesRecommended: [],
  chargeSources: [],
  benchmarks: [],
  cashFund: [],
  benchmarkConfig: []
};

export default createReducer(INITIAL_STATE, {
  [META_LOADED]: state => {
    state.isMetaLoaded = !state.isMetaLoaded;
  },
  [SET_IS_LOADING_META]: (state, action) => {
    state.isLoadingMeta = action.payload;
  },
  [GET_META_TIME_HORIZON]: (state, action) => {
    state.timeHorizons = action.payload.data;
  },
  [GET_META_RISK_LEVEL]: (state, action) => {
    state.riskLevels = action.payload.data;
  },
  [GET_META_ASSET_CLASS]: (state, action) => {
    state.assetClasses = action.payload.data;
  },
  [GET_META_KNOWLEDGE_LEVEL]: (state, action) => {
    state.knowledgeLevels = action.payload.data;
  },
  [GET_META_POLICY_PROVIDER]: (state, action) => {
    state.policyProviders = action.payload.data;
  },
  [GET_META_POLICY_TYPE]: (state, action) => {
    state.policyTypes = action.payload.data;
  },
  [GET_META_POLICY_PLATFORM]: (state, action) => {
    state.policyPlatforms = action.payload.data;
  },
  [GET_META_POLICY_CHARGE_TYPE]: (state, action) => {
    // FIX for changing charge name, note that this should be changed on BE when they fix their code
    const adjustedData = action.payload.data
      .map(({ name, value }: MetaType) => {
        if (value === '8') {
          return {
            name: 'Aggregate Portfolio management charge',
            value: value
          };
        } else {
          return { name, value };
        }
      })
      .sort((a: MetaType, b: MetaType) => (a.name > b.name && 1) || -1);

    state.policyChargeTypes = adjustedData;
  },
  [GET_META_RISK_ASSET_ALLOCATION]: (state, action) => {
    state.riskAssetAllocations = action.payload.data;
  },
  [GET_META_RETURN_FORECASTS]: (state, action) => {
    state.returnForecasts = action.payload.data;
  },
  [GET_META_RETURN_FORECAS_TYPES]: (state, action) => {
    state.returnForecastTypes = action.payload.data;
  },
  [GET_META_RISK_CAPACITY]: (state, action) => {
    state.riskCapacity = action.payload.data;
  },
  [GET_RISK_REQUIREMENT_LEVELS]: (state, action) => {
    state.riskRequirementLevels = action.payload.data;
  },
  [GET_META_POLICY_ACTION_TYPE]: (state, action) => {
    state.policyActionTypes = action.payload.data;
  },
  [SET_META_CONTRIBUTION_ACCOUNTS]: (state, action) => {
    state.contributionAccounts = action.payload.data;
  },
  [SET_META_CONTRIBUTION_FREQUENCIES]: (state, action) => {
    state.contributionFrequencies = action.payload.data;
  },
  [SET_META_CONTRIBUTION_SOURCES]: (state, action) => {
    state.contributionSources = action.payload.data;
  },
  [SET_META_ADVISOR_CHARGE_TYPES]: (state, action) => {
    state.advisorChargeTypes = action.payload.data;
  },
  [SET_META_ADVISOR_CHARGE_ACCOUNTS]: (state, action) => {
    state.advisorChargeAccounts = action.payload.data;
  },
  [SET_RISK_DESCRIPTIONS]: (state, action) => {
    state.riskDescriptions = action.payload.data;
  },
  [SET_META_ASSET_CLASSES]: (state, action) => {
    state.assetClassesNew = action.payload.data;
  },
  [SET_META_CIP_THRESHOLDS]: (state, action) => {
    state.cipThresHolds = action.payload.data;
  },
  [SET_MODEL_PORTFOLIOS]: (state, { payload }) => {
    state.modelPortfolios = payload.data;
  },
  [SET_POLICY_TYPE_RECOMMENDED]: (state, { payload }) => {
    state.policyTypesRecommended = payload.data;
  },
  [SET_CHARGE_SOURCES]: (state, { payload }) => {
    state.chargeSources = payload.data;
  },
  [SET_BENCHMARKS]: (state, { payload }) => {
    state.benchmarks = payload.data;
  },
  [SET_CASH_FUND]: (state, { payload }) => {
    state.cashFund = payload.data;
  },
  [SET_BENCHMARK_CONFIG]: (state, { payload }) => {
    state.benchmarkConfig = payload.data;
  }
});
